import ToastComponent from './Toast.vue'
import Vue from 'vue'

const ToastConstructor = Vue.extend(ToastComponent)
const toastPool = []

const getAnInstance = () => {
  if (toastPool.length > 0) {
    const instance = toastPool[0]
    toastPool.splice(0, 1)
    return instance
  }
  return new ToastConstructor({
    el: document.createElement('div')
  })
}

const Toast = (options = {}) => {
  const instance = getAnInstance()
  instance.msg = options.msg
  instance.type = options.type
  document.body.appendChild(instance.$el)
  clearTimeout(instance.timer)
  Vue.nextTick(() => {
    instance.value = true
    instance.timer = setTimeout(() => {
      instance.value = false
    }, 1500)
  })
  return instance
}

export default Toast
